import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Container } from 'react-bootstrap'
import "./styles/customergroups-styles.scss"
import CustomerGroupsTableTopBar from './includes/CustomerGroupsTable/CustomerGroupsTableTopBar'
import CustomerGroupsTable from './includes/CustomerGroupsTable/CustomerGroupsTable'
import { toast } from 'react-toastify';
import { getCustomerGroups, deleteCustomerGroup } from 'utlis/Apis/Customers_API'
import SectionLoading from 'utlis/helpers/SectionLoading/SectionLoading'
import Pagination from 'components/CommonComponents/Pagination'
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions'
import useQuery from 'utlis/CustomHooks/useQueryHook'
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    ERROR_WHILE_FETCHING_CUSTOMERGROUPS,
    ERROR_WHILE_DELETING_CUSTOMERGROUP,
    CONFIRMATION_BEFORE_DELETING_CUSTOMERGROUP,
    CUSTOMERGROUP_DELETED_SUCCESSFULLY,
} from 'utlis/AppMessages/AppMessages'

function CustomerGroups(props) {
    const loadingCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

    const [customergroups, setCustomerGroups] = useState([])
    const [loading, setLoading] = useState(true)

    const [allCheckboxSelected, setAllCheckboxesSelected] = useState(false)

    const [column__GroupName, setColumn__GroupName] = useState(true)
    const [column__Status, setColumn__Status] = useState(true)
    const [column__DiscountPercent, setColumn__DiscountPercent] = useState(true)
    const [column__DiscountValue, setColumn__DiscountValue] = useState(true)

    const [sectionLoadingVisible, setSectionLoadingVisible] = useState(false)

    const [paginationLinks, setPaginationLinks] = useState([])

    const [searchQuery, setSearchQuery] = useState("")

    let query = useQuery();
    let page = query.get('page')
    let keyword = query.get('keyword')

    useEffect(() => {
        let URLParams = `${(keyword) ? "keyword=" + keyword + "&" : ""}${page ? "page=" + page : ""}`
        setSectionLoadingVisible(true)

        getCustomerGroups(props.currentUser.userToken, URLParams).then(res => {
            setSectionLoadingVisible(false)
            setLoading(false)

            const resData = res.data

            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setPaginationLinks(resData.links)
                setCustomerGroups(resData.data)
            }

            if (resData && resData.error) {
                toast.dismiss();

                toast.error(ERROR_WHILE_FETCHING_CUSTOMERGROUPS, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCustomerGroups `, err.message)

            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setSectionLoadingVisible(false)
                    setLoading(false)
                }
            })
        })
    }, [keyword, page, props])

    const handleSelectAllChange = (ev) => {
        const checkboxes = document.getElementsByClassName('all-checkboxes-selector-checkbox')
        setAllCheckboxesSelected(!allCheckboxSelected)
        setTimeout(() => {
            if (ev.target.checked) {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = true
                });
            } else {
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = false
                });
            }
        }, 50);
    };

    const handleDelete = (ev, groupId) => {
        ev.preventDefault()

        var confirmation = window.confirm(CONFIRMATION_BEFORE_DELETING_CUSTOMERGROUP)

        if (confirmation) {
            setSectionLoadingVisible(true)

            deleteCustomerGroup(props.currentUser.userToken, groupId).then(res => {

                setSectionLoadingVisible(false)

                const deletedData = res.data
                if (deletedData.success) {
                    const filtersCustomerGroupsList = customergroups.filter(item => item.blog_id !== groupId)

                    setCustomerGroups(filtersCustomerGroupsList)

                    toast.dismiss();
                    toast.success(CUSTOMERGROUP_DELETED_SUCCESSFULLY, {
                        autoClose: 2500,
                    })
                }

                if (deletedData.error) {
                    console.log(ERROR_WHILE_DELETING_CUSTOMERGROUP, res)
                    toast.dismiss();

                    toast.error(ERROR_WHILE_DELETING_CUSTOMERGROUP, {
                        autoClose: 2500,
                        onClose: () => {
                        }
                    })
                }

            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} deleteCustomerGroup `, err.message)

                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        setSectionLoadingVisible(false)
                    }
                })
            })
        }
    }

    const handleSearchChange = debounce(ev => {
        let searchQueryValue = ev.target.value
        setSectionLoadingVisible(true)
        if (searchQueryValue && searchQueryValue.length) {
            setSearchQuery(searchQueryValue)
            props.history.push(`/customers/groups?keyword=${searchQueryValue}&page=1`)
        }
        if (!searchQueryValue) {
            setSearchQuery("")
            props.history.push(`/customers/groups?page=1`)
        }
    }, 500)

    return (
        <section id="app-customergroups" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-customergroups">
                    <div className="app-header-wrapper d-flex mb-2">
                        <p className="app-heading text-capitalize">Customer Group</p>
                    </div>
                    <div className="app-content-container">
                        <div className="app-card">
                            <div className="app-card-content bg-white border st-border-light st-default-rounded-block mb-3">
                                <div className="acc_top-bar border-bottom st-border-light">
                                    <CustomerGroupsTableTopBar
                                        column__GroupName={column__GroupName}
                                        column__DiscountPercent={column__DiscountPercent}
                                        column__DiscountValue={column__DiscountValue}
                                        column__Status={column__Status}

                                        setColumn__GroupName={bool => setColumn__GroupName(bool)}
                                        setColumn__DiscountPercent={bool => setColumn__DiscountPercent(bool)}
                                        setColumn__Status={bool => setColumn__Status(bool)}
                                        setColumn__DiscountValue={bool => setColumn__DiscountValue(bool)}

                                        handleSearchChange={handleSearchChange}
                                    />
                                </div>

                                <div className="st-listing-table customergroups-table">
                                    <CustomerGroupsTable
                                        allCheckboxSelected={allCheckboxSelected}
                                        handleSelectAllChange={ev => handleSelectAllChange(ev)}
                                        column__GroupName={column__GroupName}
                                        column__DiscountPercent={column__DiscountPercent}
                                        column__Status={column__Status}
                                        column__DiscountValue={column__DiscountValue}

                                        loadingCount={loadingCount}
                                        loading={loading}

                                        customerGroups={customergroups}

                                        handleDelete={(ev, groupId) => handleDelete(ev, groupId)}
                                    />
                                    {
                                        sectionLoadingVisible && (
                                            <SectionLoading />
                                        )
                                    }
                                </div>
                            </div>

                            <div className="pagination-container d-flex justify-content-end">
                                <Pagination
                                    searchQuery={searchQuery}
                                    routeName={"/customers/groups"}
                                    paginationLinks={paginationLinks}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
//     }
// }

export default connect(getDataFromStore, null)(CustomerGroups)